module.exports = __webpack_public_path__ + "img/depreciation-fee-icon.468c085f.svg";